import { createContext, useContext } from "react";
import type { ApiErrorDetails } from "./apiErrors";

export interface ApiErrorContextState {
  reportError: (error: unknown) => void;
  terminalError?: ApiErrorDetails;
}

export const ApiErrorContext = createContext<ApiErrorContextState>({
  reportError: () => {},
});

export function useApiErrorContext() {
  return useContext(ApiErrorContext);
}
